import { roundValue, safeParseFloat } from "lib/number";
import { getChildrenTotalRetail } from "../column-formula/total-retail";
import { getChildrenUnits } from "../column-formula/units";
import { referenceMetricValueOrCompute } from "../sibling-value-getter";
import { MetricsKind } from "../types";

export const AUR = ({ factoryOptions, getterParams }) => {
    const units = referenceMetricValueOrCompute(
        () => {
            let totalUnits = 0;
            getterParams.api.forEachNodeAfterFilter((rowNode) => {
                // We only need to include outer row. `getChildrenUnits` will count nested children
                if (rowNode.level === 0) {
                    totalUnits += getChildrenUnits(factoryOptions, {
                        ...getterParams,
                        node: rowNode,
                        data: rowNode.data,
                    });
                }
            });

            return totalUnits;
        },
        getterParams,
        MetricsKind.UNITS,
        undefined,
        undefined,
        factoryOptions.disableSiblingOptimization
    );

    const totalRetail = referenceMetricValueOrCompute(
        () => {
            let totalRetail = 0;
            getterParams.api.forEachNode((rowNode) => {
                // We only need to include outer row. `getChildrenTotalRetail` will count nested children
                if (rowNode.level === 0) {
                    totalRetail += getChildrenTotalRetail(factoryOptions, {
                        ...getterParams,
                        node: rowNode,
                        data: rowNode.data,
                    });
                }
            });

            return totalRetail;
        },
        getterParams,
        MetricsKind.TOTAL_RETAIL,
        undefined,
        undefined,
        factoryOptions.disableSiblingOptimization
    );

    const roundedValue = roundValue(safeParseFloat(totalRetail / units, 0), 1);
    if (roundedValue === 0) {
        return "";
    }
    return roundedValue;
};
